<template>
  <div class='moreReport'>
    <template v-if="data.dataType == -2">
      <!-- <template v-if="data.jsonData && data.jsonData.recommendQ && data.jsonData.recommendQ.length > 0"> -->
        <div class="btnGroup">
          <el-button plain class="marginLeft0" v-for="(item, index) in data.jsonData.recommendQ" :key="index" @click="sendQuest(item)">{{ item }}</el-button>
        </div>
      <!-- </template>
      <template v-else> -->
        <div class="btnGroup" v-for="item in data.jsonData.idTitle" :key="item.id">
          <el-button plain @click="setQusetType(item)">
            <svg-icon name="pdf" style="font-size: 24px;"></svg-icon>
            <span>{{ $i18.language("加载") }}《{{ item.title }}》{{ $i18.language("提问") }}</span>
          </el-button>
          <el-button plain @click="goMarketResearch(item)" class="lineHeight24">{{ $i18.language("前往") }}《{{ item.title }}》</el-button>
        </div>
      <!-- </template> -->
    </template>
    <template v-else-if="data.dataType == -3">
      <el-button v-if="data.tabledata.result.companyID" plain class="marginLeft0" @click="goContactCompany('companyID')">{{ $i18.language("查看公司详情") }}</el-button>
      <el-button v-if="data.tabledata.result.searchKey" plain class="marginLeft0" @click="goContactCompany('searchKey')">{{ $i18.language("查看公司联系人") }}</el-button>
    </template>
  </div>
</template>

<script>
export default {
  props: {
    data: Object
  },
  data() {
    return {

    };
  },
  created() {
    
  },
  mounted() {

  },
  methods: {
    sendQuest(text) {
      console.log(this.data);
      this.$emit('sendQuest', text, this.data.jsonData.idTitle[0])
    },
    setQusetType(row) {
      this.$emit('setQusetType', row)
    },
    goMarketResearch(row) {
      window.open(`/gt6/analysis/detail?id=${row.id}&reportLanguage=${localStorage.getItem("language")}&wlf=ai_gpt`)
      // this.$router.push(`/gt6/analysis/detail?id=${row.id}&reportLanguage=zh`)
    },
    goContactCompany(type) {
      if (type == 'companyID') {
        let id = this.data.tabledata.result.companyID
        window.open(this.$util.getCurrentWebSiteByProduct() + `/company/detail/${id}/0?wlf=ai_gpt`)
      } else {
        let key = this.data.tabledata.result.searchKey
        let name = this.data.tabledata.result.domainName
        let search = this.data.tabledata.result.search
        let country = this.data.tabledata.result.country
        let searchtype = this.data.tabledata.result.searchType
        let sourceType = this.data.tabledata.result.sourceType
        window.open(this.$util.getCurrentWebSite() + `/sou/search/detail/${name}?sou_search_key=${key}&search=${search}&country=${country}&searchtype=${searchtype}&sourceType=${sourceType}`)
      }
    },
  },
};
</script>

<style scoped lang="scss">
.moreReport {
  .btnGroup {
    display: flex;
    flex-wrap: wrap;
    .lineHeight24 {
      line-height: 24px;
    }
    /deep/ .el-button {
      > span {
        // display: flex;
        // align-items: center;
        // flex-direction: row;
      }
    }
  }
}
.el-button {
  margin-top: 8px;
  border-radius: 6px;
  &:hover, &:focus {
    color: $--color-link;
    border: 1px solid $--color-link;
  }
}
.marginLeft0 {
  margin: 0 !important;
  margin-right: 5px !important;
  margin-top: 5px !important;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-all;
  white-space: nowrap;
}
</style>
